export class FlatPaymentInfo {
    FlatId: number;
    FlatNo: string;
    Size: string;
    Face: string;
    NoOfBeds: number;
    Price: number;
    Parking: number;
    CustomerID: number;
    BasicCost: number;
    ParkingCost:number;
    ClubHouseCost:number;
    EastFacingPlc:number;
    FloorRisePlc:number;
    InfrastructureCost:number;
    MaintenanceCharges:number;
    CarpusFund:number;
    FaceView:string;
}